/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

// TODO: Z nějakého důvodu eslint nezná FileSystemAccessAPI.
/* global FileSystemFileHandle  */

import isNil from 'lodash/isNil';

import UpdatePlatform from '../../platform/update-platform';

/**
 * @private
 * @typedef {Record<string, *>} AppManager TODO #555
 */

export default class BrowserCapabilities {
  /**
   * @param {AppManager} appManager
   */
  constructor(appManager) {
    this.updatePlatform = appManager.getUpdatePlatform();
  }

  /**
   * Zjistí podporu File System Access API pro možnost využití Origin Private File System.
   * @returns {boolean}
   */
  fileSystemAccessApi() {
    return isFileSystemAccessApiSupported();
  }

  /**
   * @returns {boolean} True, pokud je podporováné seekování ve videu na zařízení, jinak false;
   */
  seek() {
    // Property pictureInPictureEnabled je dostupná od Chrome 69.
    return !isNil(document.pictureInPictureEnabled);
  }

  /**
   * // TODO: vymyslet jak nemít funkci jako Promise
   * @returns {Promise<boolean>} True, pokud jsou podporované přechody na zařízení, jinak false;
   */
  transitions() {
    return new Promise((resolve) =>
      resolve(
        this.updatePlatform.then((updatePlatform) => {
          switch (updatePlatform) {
            case UpdatePlatform.KiwiLighter1:
            case UpdatePlatform.Web:
            case UpdatePlatform.WebosSignage3_0:
              // Property pictureInPictureEnabled je dostupná od Chrome 69.
              return !isNil(document.pictureInPictureEnabled);
            default:
              return false;
          }
        })
      )
    );
  }
}

export function isFileSystemAccessApiSupported() {
  return (
    typeof FileSystemFileHandle !== 'undefined' &&
    typeof FileSystemFileHandle.prototype.createWritable === 'function'
  );
}
